import { Pipe, PipeTransform } from "@angular/core";
import { Operator } from "../reporting.type";

@Pipe({ name: "getOperatorTitleById" })
export class GetOperatorTitleByIdPipe implements PipeTransform {
  transform(operatorId: string, operators: Operator[]): string {
    if (!operatorId) {
      return;
    }

    for (const operator of operators) {
      if (operator.id === operatorId) {
        return operator.title;
      }
    }
  }
}
